import { createContext } from 'react';
import IUser from '@cc/shared-service/src/server/types/response/IUser';

export interface IAppContext {
  isAuthenticated: boolean;
  logout: () => void;
  currentUser?: IUser | null;
  accessToken?: string | null;
  craDefaultValues?: any | null;
}

export const defaultContext: IAppContext = {
  isAuthenticated: false,
  logout: () => () => {},
  craDefaultValues: {},
};

const AppContext = createContext<IAppContext>(defaultContext);

export default AppContext;
